import { IconFn, IconSvg } from "../createIcon";

export const MinusIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 48, height: 48 }} {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 21.7143H20.7143H26.2857H43V27.2857H26.2857H20.7143H4V21.7143Z"
      fill={color}
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M20.7143 27.2857V21.7143H26.2857V27.2857H20.7143Z" fill={color} />
  </IconSvg>
);
